<template>
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-8">
      <div class="video-wrapper" ref="videoWrapper">
        <div ref="player" ></div>
        <iframe
          v-if="!isYoutubeVideo"
          :src="video.url"
          ref="iframe"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          referrerpolicy="strict-origin-when-cross-origin">
        </iframe>
      </div>
      <h2 class="video-title">{{ video.title }}</h2>
      <video-header
        :category="category"
        :video="video"
        @handleLikeVideo="handleLikeVideo"
      />
      <video-description :video="video" @seekTo="handleSeek" class="mr-b-10" />
      <h3 v-if="!video.enableLiveChat" class="font-bold">{{ video.comments }} 件のコメント</h3>
      <div v-if="!video.enableLiveChat" ref="videoCommentsWrapper" class="video-comments-wrapper">
        <video-comments
          :video="video"
          :comments="comments"
          :sellerId="sellerId"
          @submitComment="submitComment"
          @updateComment="updateComment"
          @handleLikeComment="handleLikeComment"
          @submitReply="submitReply"
          @seekTo="handleSeek"
        />
      </div>
    </div>
    <related-videos
      class="col-sm-12 col-md-12 col-lg-4"
      :videos="videos"
      :categoryId="categoryId"
      ref="relatedVideos"
      @openUpgradePlanModal="$emit('openUpgradePlanModal')"
      @handleClickViewVideo="$emit('handleClickViewVideo', $event)"
    />
  </div>
</template>
<script>
import Videoservice from '../../services/videoservice'
import LikeButton from './components/LikeButton'
import VideoHeader from './components/VideoHeader'
import VideoDescription from './components/VideoDescription'
import VideoComments from './components/VideoComments'
import RelatedVideos from './components/RelatedVideos'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    LikeButton,
    VideoHeader,
    VideoDescription,
    VideoComments,
    RelatedVideos
  },
  data () {
    return {
      loader: null,
      loaderComments: null,
      player: null,
      isPlayerReady: false,
      comments: []
    }
  },
  computed: {
    sellerId () {
      return this.$store.getters.getUser.sellerId
    },
    videos () {
      return this.$store.getters.getVideos
    },
    videoId () {
      return Number(this.$route.params.id)
    },
    video () {
      return this.videos.find(v => v.id === this.videoId)
    },
    categoryId () {
      return this.video.category
    },
    categories () {
      return this.$store.getters.getCategories
    },
    category () {
      return this.categories.find(i => { return i.id === this.categoryId })
    },
    isYoutubeVideo () {
      const u = new URL(this.video.url)
      return u.hostname.includes('youtube')
    }
  },
  async mounted () {
    if (!this.videoId) {
      this.$router.push('/not-found')
      return
    }
    this.loader = this.$loading.show()
    await this.init()
    await this.initYouTubePlayer()
    this.loader && this.loader.hide()

    this.syncPlaylistHeight()
    window.addEventListener('resize', this.syncPlaylistHeight)
  },
  methods: {
    async init () {
      const logParams = {
        name: eventCode.video.play,
        properties: {
          videoId: this.videoId
        }
      }
      EventService.postTrackLog(logParams)
      await this.getVideo()
      this.getComments()
    },
    async initYouTubePlayer () {
      if (!this.isYoutubeVideo) return

      if (this.player && this.isPlayerReady) return

      const videoId = this.extractVideoId(this.video.url)
      this.player = new window.YT.Player(this.$refs.player, {
        videoId,
        playerVars: {
          origin: window.location.origin,
          playsinline: 1
        },
        events: {
          onReady: this.onPlayerReady
        }
      })
    },
    extractVideoId (url) {
      const u = new URL(url)
      if (u.hostname.includes('youtube')) {
        return u.pathname.slice(7)
      }
      return u.searchParams.get('v')
    },
    onPlayerReady () {
      this.isPlayerReady = true

      const t = parseInt(this.$route.query.t)
      if (t > 0) {
        this.player.seekTo(t, true)
      }
    },
    loadingComments () {
      this.loaderComments && this.loaderComments.hide()
      this.loaderComments = this.$loading.show({
        container: this.$refs.videoCommentsWrapper,
        backgroundColor: 'rgba(255,255,255,0.7)',
        canCancel: false,
        width: 40,
        height: 40
      })
    },
    getComments () {
      this.loadingComments()
      this.comments = []
      Videoservice.getComments({ videoId: this.videoId })
        .then((response) => {
          this.comments = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loaderComments && this.loaderComments.hide()
        })
    },
    async getVideo () {
      await Videoservice.getVideo({ videoId: this.videoId })
        .then((response) => {
          if (!this.video.url) {
            this.video.url = response.data.url
          }
          this.video.enableLiveChat = response.data.enableLiveChat
          this.video.liked = response.data.liked
          this.video.likes = response.data.likes
          this.video.comments = response.data.comments
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
    },
    syncPlaylistHeight () {
      this.$nextTick(() => {
        const wrapper = this.$refs.videoWrapper
        const playlist = this.$refs.relatedVideos.$refs.playList
        const liveChat = this.$refs.relatedVideos.$refs.liveChat
        if (wrapper && playlist) {
          if (window.innerWidth > 1024) {
            playlist.style.maxHeight = wrapper.clientHeight + 'px'
          } else {
            playlist.style.maxHeight = 'unset'
          }
        }

        if (wrapper && liveChat) {
          if (window.innerWidth > 1024) {
            liveChat.style.height = wrapper.clientHeight + 'px'
          } else {
            liveChat.style.removeProperty('height')
          }
        }
      })
    },
    handleLikeVideo () {
      if (!this.video.liked) {
        const logParams = {
          name: eventCode.video.like,
          properties: {
            videoId: this.videoId
          }
        }
        EventService.postTrackLog(logParams)
        this.video.likes += 1
        this.video.liked = true
        Videoservice.likeVideo({ videoId: this.videoId })
      }
    },
    async submitComment (newComment) {
      this.loadingComments()
      const logParams = {
        name: eventCode.video.comment,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      await Videoservice.postComment({ videoId: this.videoId, content: newComment })
        .then((response) => {
          this.comments.unshift(response.data)
          this.video.comments += 1
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loaderComments && this.loaderComments.hide()
        })
    },
    async updateComment (comment) {
      this.loadingComments()
      const logParams = {
        name: eventCode.video.comment,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      await Videoservice.putComment({ commentId: comment.id, content: comment.content })
        .then((response) => {
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loaderComments && this.loaderComments.hide()
        })
    },
    async submitReply (comment, content) {
      this.loadingComments()
      const logParams = {
        name: eventCode.video.comment,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      await Videoservice.postComment({ videoId: this.videoId, content: content, parentId: comment.id })
        .then((response) => {
          comment.replies.push(response.data)
          comment.isShowReplies = true
          this.video.comments += 1
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loaderComments && this.loaderComments.hide()
        })
    },
    handleLikeComment (comment) {
      if (!comment.liked) {
        const logParams = {
          name: eventCode.video.like_comment,
          properties: {}
        }
        EventService.postTrackLog(logParams)

        comment.likes += 1
        comment.liked = true
        Videoservice.likeComment({ commentId: comment.id })
      }
    },
    handleSeek (seconds) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          t: seconds
        }
      })
      this.seekTo(seconds)
    },
    seekTo (seconds) {
      if (!this.player || !this.isPlayerReady) return
      this.player.seekTo(seconds, true)
    }
  },
  watch: {
    async videoId () {
      if (!this.video) {
        this.$router.push('/not-found')
      } else {
        if (this.player && this.isPlayerReady) {
          this.player.pauseVideo()
        }

        if (!this.isYoutubeVideo && this.player) {
          this.player.destroy()
          this.player = null
          this.isPlayerReady = false
        }
        this.loader = this.$loading.show()
        await this.init()
        await this.initYouTubePlayer()
        this.loader && this.loader.hide()

        if (!this.player || !this.isPlayerReady) return
        const videoId = this.extractVideoId(this.video.url)
        this.player.loadVideoById(videoId)
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    if (this.player) {
      this.player.destroy()
    }
    window.removeEventListener('resize', this.syncPlaylistHeight)
  }
}
</script>
<style>
.video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
<style scoped>
.hpanel {
  background-color: #fff;
  padding: 20px;
}
.video-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}
.video-title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0 8px;
}
.video-comments-wrapper {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/view/video/VideoPlayer.vue